import { includes, startsWith } from 'lodash';

export interface RouterFeature {
  router: RouterState;
}

export interface RouterState {
  readonly name: string;
  readonly url: string;
  readonly params: { [name: string]: string };
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RouterStateHelpers {
  export function isEditor(router: RouterState): boolean {
    return !!router && startsWith(router.name, 'application');
  }
  export function isReport(router: RouterState): boolean {
    return !!router && startsWith(router.name, 'reportShow');
  }
  export function isReportDetails(router: RouterState): boolean {
    return (
      !!router &&
      /^reportShow(\.runs|\.noRuns)?\.(details|notebook|presentation|python|queries|queries\.data)/.test(router.name)
    );
  }
  export function isVizLightbox(router: RouterState): boolean {
    return !!router && includes(router.url, '/viz/');
  }
  export function isPythonLightbox(router: RouterState): boolean {
    return !!router && includes(router.url, '/pythonviz/');
  }
  export function isNotebook(router: RouterState): boolean {
    return !!router && includes(router.url, '/notebook');
  }
}
